import { Container, Typography } from "@mui/material";

import useStyles from "./styles";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import CeroInput from "../../components/CeroInput";
import CeroButton from "../../components/CeroButton";
import { APIEndpoints } from "../../redux/constants";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const SupplierSelfAssessment = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});
  const { surveyId, token } = useParams();
  const [questions, setquestions] = useState([]);
  const [email, setEmail] = useState("");
  const [validIndicator, setValidIndicator] = useState(true);
  const [validIndicatorMsg, setValidIndicatorMsg] =
    useState("Url Is Not Valid");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${APIEndpoints.GET_SUPPLIER_SELF_ASSESSMENT_QUESTIONS}/${surveyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200 && response?.data?.questions) {
          setquestions(response?.data?.questions);
          setEmail(response?.data?.email);
        } else {
          setValidIndicator(false);
          setValidIndicatorMsg(response?.data?.detail);
        }
      } catch (error) {
        setValidIndicator(false);
        setValidIndicatorMsg(error?.response?.data?.detail);
      }
    };

    fetchData();
  }, [dispatch, surveyId, token]);

  const handleInputChange = (questionId, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: value,
    }));
  };

  const renderProfileQuestions = () => {
    return (
      questions?.length &&
      questions
        ?.filter((item) => item.section === "Company Profile")
        ?.map((item, index) => {
          if (item.question.toLowerCase() === "email") {
            answers[item._id] = email;
          }
          return (
            <div className={classes.eachProfile}>
              <Typography>{`${index + 1}.${item.question}`}</Typography>
              <CeroInput
                classes={{
                  container: classes.inputContainer,
                }}
                variant="outlined"
                placeholder={`Enter ${item.question}`}
                multiline
                rows={3}
                value={answers[item._id] || ""}
                onChange={(e) => handleInputChange(item._id, e.target.value)}
                className={classes.input}
                disabled={item.question.toLowerCase() === "email"}
              />
            </div>
          );
        })
    );
  };

  const GroupedQuestions = () => {
    // Group questions by section
    var qtnNumber = 0;
    const groupedQuestions = questions?.reduce((acc, curr) => {
      if (curr.section?.toLowerCase() === "company profile") return acc;
      if (!acc[curr.section]) acc[curr.section] = [];
      acc[curr.section].push(curr);
      return acc;
    }, {});

    return (
      <div>
        {groupedQuestions &&
          Object.entries(groupedQuestions)?.map(([section, questions]) => (
            <div key={section}>
              <h3>{section}</h3>
              {questions.map((q) => {
                qtnNumber += 1;
                return (
                  <div key={q._id} style={{ marginBottom: "1rem" }}>
                    <p>{`${qtnNumber}.${q.question}`}</p>
                    <label>
                      <input
                        type="radio"
                        name={q._id}
                        value="yes"
                        checked={answers[q._id]?.toLowerCase() === "yes"}
                        onChange={() => handleInputChange(q._id, "Yes")}
                        style={{ accentColor: "#8C2148" }}
                      />
                      Yes
                    </label>
                    <label style={{ marginLeft: 10 }}>
                      <input
                        type="radio"
                        name={q._id}
                        value="no"
                        checked={answers[q._id]?.toLowerCase() === "no"}
                        onChange={() => handleInputChange(q._id, "No")}
                        style={{ accentColor: "#8C2148" }}
                      />
                      No
                    </label>
                  </div>
                );
              })}
            </div>
          ))}
      </div>
    );
  };
  const submitSurvey = async () => {
    try {
      const response = await axios.post(
        `${APIEndpoints.SUBMIT_SUPPLIER_SELF_ASSESSMENT}/${surveyId}`,
        { answers: answers }, // Replace with actual data if needed, or keep as {} if no body required
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) navigate("/self-assessment/sucess");
      else setValidIndicator(false);
    } catch (error) {
      setValidIndicator(false);
    }
  };
  const isFormValid = () => {
    const allIdsExist = questions.every((q) => answers.hasOwnProperty(q._id));
    return allIdsExist;
  };

  return (
    <Container className={classes.container}>
      {validIndicator ? (
        <>
          <div className={classes.topHeading}>
            <Typography
              variant="h4"
              component="h4"
              className={classes.mainHeading}
            >
              Self Assessment Quesntionnaire
            </Typography>
            <Typography variant="h5" component="h4" marginTop={7}>
              Find out how ESG-ready your company is in under a minute !
            </Typography>
          </div>
          <div className={classes.profileBlock}>{renderProfileQuestions()}</div>
          <div className={classes.profileBlock}>
            <span className={classes.instructionBox}>
              <Typography>Answer </Typography>
              <Typography className={classes.emphText}>Yes</Typography> or
              <Typography className={classes.emphText}> No </Typography>
              <Typography>to these simple questions:</Typography>
            </span>
          </div>
          <div>{GroupedQuestions()}</div>
          <div>
            <div className={classes.buttonSubmitContainer}>
              <CeroButton
                buttonText="Submit Survey"
                className={classes.buttonPrimary}
                onClick={submitSurvey}
                disabled={!isFormValid()} // Disable if invalid
              />
            </div>
          </div>
        </>
      ) : (
        <Typography
          variant="h4"
          component="h4"
          className={classes.mainHeading}
          style={{ textAlign: "center" }}
        >
          {validIndicatorMsg}
        </Typography>
      )}
    </Container>
  );
};

export default SupplierSelfAssessment;
